import { cn } from '@/lib/cn';

/** The company mark, always from the stored asset (never redrawn): dark on light grounds, cream on dark. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <>
      <img src="/brand/booklyn-mark-black.svg" alt="Booklyn Room Map Pro" className={cn('h-6 w-auto dark:hidden', className)} />
      <img src="/brand/booklyn-mark-color.svg" alt="Booklyn Room Map Pro" className={cn('hidden h-6 w-auto dark:block', className)} />
    </>
  );
}
